<template>
	<div>
		<!-- Header -->
		<div class="flex wrap xs-12 min-height mb2">
			<div class="flex xs-12 md-6 xs-left xs-middle">
				<h2 class="fs7 lh125 fw7 c1 mr4">{{ $t("offer") }}</h2>
			</div>
		</div>
		<div class="c2 cu2" @click="$emit('go:back')">{{ $t("back") }}</div>

		<!-- Credentials -->
		<offer-detail-credentials class="mt6" />

		<!-- Product -->
		<offer-detail-product class="mt6" />

		<!-- Benefit Options -->
		<offer-detail-benefit-options class="mt6" />

		<!-- Benefit Summary -->
		<offer-detail-benefit-summary class="mt6" />

		<!-- Premium -->
		<offer-detail-premium class="mt6" />

		<!-- Values -->
		<!-- <offer-detail-values class="mt6" /> -->

		<!-- Facts -->
		<offer-detail-facts class="mt6" />

		<!-- Stakeholders -->
		<offer-detail-stakeholders class="mt6" />

		<!-- Commissions -->
		<offer-detail-commissions class="mt6" />

		<!-- Clauses -->
		<offer-detail-clauses class="mt7" />

		<!-- Exclusions -->
		<exclusions-info class="mt6" :has-actions="true" />

		<slot />
	</div>
</template>

<script>
import OfferDetailProduct from "./OfferDetailProduct"
import OfferDetailPremium from "./OfferDetailPremium"
import OfferDetailCredentials from "./OfferDetailCredentials"
import OfferDetailFacts from "./OfferDetailFacts"
import OfferDetailStakeholders from "./OfferDetailStakeholders"
import OfferDetailCommissions from "./OfferDetailCommissions"
import OfferDetailBenefitOptions from "./OfferDetailBenefitOptions"
import OfferDetailBenefitSummary from "./OfferDetailBenefitSummary"
import OfferDetailClauses from "./OfferDetailClauses"
import ExclusionsInfo from "./ExclusionsInfo"

export default {
	components: {
		OfferDetailProduct,
		OfferDetailPremium,
		OfferDetailCredentials,
		OfferDetailFacts,
		OfferDetailStakeholders,
		OfferDetailCommissions,
		OfferDetailBenefitOptions,
		OfferDetailBenefitSummary,
		OfferDetailClauses,
		ExclusionsInfo
	}
}
</script>
